import { memo, ReactNode, useCallback, useState } from 'react';

import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';
import SectionMessage from '@atlaskit/section-message';

import { MessageCloseButton, MessageWrapper } from './styled';

export interface Props {
  type: 'warning' | 'error' | 'information';
  onMessageClose?: (params?: any) => any;
  options?: any;
  children?: ReactNode;
}

const Message = ({ type, options, onMessageClose, children }: Props) => {
  const [isClosed, setIsClosed] = useState(false);

  const closeMessage = useCallback(() => {
    setIsClosed(true);
    onMessageClose?.();
  }, [setIsClosed, onMessageClose]);
  return !isClosed ? (
    <MessageWrapper>
      <SectionMessage appearance={type}>
        {children}
        {options?.closeable && (
          <MessageCloseButton>
            <IconButton
              label="close"
              onClick={closeMessage}
              appearance="subtle"
              icon={CrossIcon}
            />
          </MessageCloseButton>
        )}
      </SectionMessage>
    </MessageWrapper>
  ) : null;
};

// eslint-disable-next-line import/no-default-export
export default memo(Message);
